import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* max-width: 1200px; */
  width: 100%;
  margin: auto;
  gap: 10px;
  padding-top: 140px;

  & > section {
    & > h2 {
      font-size: 36px;
      max-width: 1200px;
      width: 100%;
      margin: auto;
      padding: 10px;
    }
  }
`;

export const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    padding-top: 140px;
    max-width: 1200px;
    width: 100%;
    margin: auto;
    padding: 24px 10px 10px 10px;
  }

  > ul {
    list-style: none;
    padding-left: 0px;
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    li {
      .subtitle-li {
        margin-top: 0px;
        padding: 10px;
        max-width: 1200px;
        width: 100%;
        margin: auto;
        display: block;
      }
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgb(222, 222, 222);
    padding-bottom: 20px;
  }
`;

export const SingleComponentWrapper = styled.div<{
  backgroundColor?: string;
  backgroundImage?: string;
  textColor?: string;
}>`
  padding: 64px 0px;
  margin: auto;

  ${(props) =>
    props.backgroundColor &&
    css`
      background: ${props.backgroundColor};

      p,
      span,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        color: ${props.textColor};
      }
    `}

  ${(props) =>
    props.backgroundImage &&
    css`
      background:
        url(${props.backgroundImage}) no-repeat,
        ${props.theme.colors.blue};
      background-position: center;
      background-size: cover;
    `};
`;
